/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ActiveCartOrderEntriesContextToken } from '@spartacus/cart/base/root';
import { OutletModule, PAGE_LAYOUT_HANDLER } from '@spartacus/storefront';
import { KnBrCartSharedModule } from './kn-br-cart-shared/kn-br-cart-shared.module';
import { KnBrMiniCartModule } from './kn-br-mini-cart/kn-br-mini-cart.module';

@NgModule({
  imports: [CommonModule, KnBrCartSharedModule, OutletModule.forChild()],
  exports: [KnBrCartSharedModule],
  providers: [
    // {
    //   provide: PAGE_LAYOUT_HANDLER,
    //   useExisting: CartPageLayoutHandler,
    //   multi: true,
    // },
    // {
    //   provide: ActiveCartOrderEntriesContextToken,
    //   useExisting: ActiveCartOrderEntriesContext,
    // },
  ],
})
export class KnBrCartBaseComponentsModule { }
